import axios from "axios";
import { toast } from "sonner";
import { Trash2, Wand2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const CategoryRulesCard = ({ rules, categories, onChange }) => {
  const label = (v) => categories.find(c => c.value === v)?.label || v;

  const remove = async (r) => {
    try {
      await axios.delete(`${API}/category-rules/${r.id}`);
      toast.success(`Rule for ${r.vendor} removed`);
      onChange();
    } catch (e) { toast.error("Could not delete rule"); }
  };

  return (
    <Card className="bg-white border border-stone-200/60 rounded-xl shadow-[0_2px_8px_rgba(0,0,0,0.04)] mt-6" data-testid="category-rules-card">
      <CardContent className="p-6">
        <h2 className="text-lg font-semibold text-stone-900 mb-1 flex items-center gap-2" style={{ fontFamily: "'Playfair Display', serif" }}>
          <Wand2 className="w-4 h-4 text-stone-500" /> Category Rules
        </h2>
        <p className="text-sm text-stone-500 mb-4">Transactions from these providers are filed automatically. Create rules when recategorizing in AI Analysis.</p>
        {rules.length === 0 ? (
          <p className="text-sm text-stone-400 py-4 text-center" data-testid="category-rules-empty">No rules yet</p>
        ) : (
          <div className="divide-y divide-stone-100">
            {rules.map(r => (
              <div key={r.id} className="flex items-center gap-3 py-2.5 text-sm" data-testid={`category-rule-${r.id}`}>
                <span className="font-medium text-stone-800">{r.vendor}</span>
                <span className="text-stone-400">→</span>
                <span className="text-xs px-2 py-0.5 rounded bg-stone-100 text-stone-700">{label(r.category)}</span>
                <span className="text-[10px] uppercase tracking-wide text-stone-400">{r.type}</span>
                <span className="ml-auto text-xs text-stone-500">{r.match_count} txn{r.match_count !== 1 ? "s" : ""}</span>
                <Button size="sm" variant="ghost" className="h-7 px-2 text-red-600 hover:bg-red-50" onClick={() => remove(r)} data-testid={`delete-rule-btn-${r.id}`}>
                  <Trash2 className="w-3.5 h-3.5" />
                </Button>
              </div>
            ))}
          </div>
        )}
      </CardContent>
    </Card>
  );
};
